export default class FileHelper {
	static async readServerFileAsync(filePath) {
		try {
			const response = await fetch(filePath);
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status} for file: ${filePath}`);
			}
			return await response.text();
		} catch (error) {
			console.error(`Could not read file: ${filePath}`, error);
			throw error;
		}
	}
}